const stats = [
  { value: "158+", label: "补档作品" },
  { value: "4", label: "覆盖年代" },
  { value: "320+", label: "修复画稿" },
  { value: "12", label: "考古专题" },
];

const quickEras = [
  { label: "1970年代 · 水墨之源", href: "#era" },
  { label: "1980年代 · 国漫黄金", href: "#era" },
  { label: "1990年代 · 引进潮", href: "#era" },
  { label: "2000年代 · 纸媒尾声", href: "#era" },
];

export default function Hero() {
  return (
    <section
      id="home"
      className="relative flex min-h-[620px] items-center justify-center overflow-hidden md:min-h-[720px]"
    >
      <img
        src="https://readdy.ai/api/search-image?query=warm%20nostalgic%20childhood%20bedroom%20filled%20with%20piles%20of%20old%20vintage%20chinese%20comic%20books%20and%20magazines%20on%20a%20wooden%20desk%2C%20soft%20amber%20afternoon%20light%20through%20curtains%2C%20stylized%20retro%20illustration%20with%20warm%20terracotta%20and%20cream%20tones%2C%20cozy%20atmosphere&width=1600&height=900&seq=hero-room-2026&orientation=landscape"
        alt="堆满老漫画与旧杂志的童年小屋，暖色灯光下充满怀旧气息"
        className="absolute inset-0 h-full w-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/35 to-background-950/70"></div>
      <div className="absolute inset-0 film-grain opacity-60"></div>

      <div className="relative z-10 mx-auto w-full max-w-5xl px-4 py-24 text-center text-background-50 md:px-6">
        <p className="mx-auto mb-5 inline-flex items-center gap-2 rounded-full border border-background-50/30 bg-background-950/40 px-4 py-1.5 text-sm tracking-widest backdrop-blur-sm">
          <i className="ri-vidicon-line text-primary-300"></i>
          老漫画补档 · 童年漫画考古
        </p>

        <h1 className="mx-auto max-w-4xl text-3xl font-bold leading-tight md:text-5xl">
          回到那间<br className="md:hidden" />
          <span className="font-display text-primary-300">堆满漫画</span>的小屋
        </h1>

        <p className="mx-auto mt-5 max-w-2xl text-sm leading-relaxed text-background-100/90 md:text-base">
          经典老番、绝版资源都在补档列表里。怀旧考古向整理齐全，老漫画按年代归档，
          点开就能找到当年那部——把藏在记忆角落的童年，一部部找回来。
        </p>

        <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <a
            href="#era"
            className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 sm:w-auto"
          >
            <i className="ri-box-3-line"></i>
            开始考古补档
          </a>
          <a
            href="#rare"
            className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/40 bg-background-50/10 px-6 py-3 text-sm font-medium backdrop-blur-sm transition-colors hover:bg-background-50/20 sm:w-auto"
          >
            <i className="ri-treasure-map-line"></i>
            查看绝版资源
          </a>
        </div>

        <div className="mx-auto mt-10 flex max-w-3xl flex-wrap items-center justify-center gap-2">
          {quickEras.map((e) => (
            <a
              key={e.label}
              href={e.href}
              className="rounded-full border border-background-50/25 bg-background-950/30 px-4 py-1.5 text-xs whitespace-nowrap transition-colors hover:bg-background-950/50"
            >
              {e.label}
            </a>
          ))}
        </div>

        <dl className="mx-auto mt-10 grid max-w-2xl grid-cols-2 gap-px overflow-hidden rounded-lg bg-background-50/15 sm:grid-cols-4">
          {stats.map((s) => (
            <div key={s.label} className="bg-background-950/30 px-3 py-4 backdrop-blur-sm">
              <dt className="text-xs text-background-100/80">{s.label}</dt>
              <dd className="mt-1 font-heading text-2xl text-primary-300">{s.value}</dd>
            </div>
          ))}
        </dl>
      </div>

      <a
        href="#era"
        aria-label="向下滚动"
        className="absolute bottom-5 left-1/2 z-10 hidden -translate-x-1/2 flex-col items-center gap-1 text-background-50/80 transition-colors hover:text-background-50 md:flex"
      >
        <i className="ri-arrow-down-line text-xl animate-bounce"></i>
      </a>
    </section>
  );
}